module.exports = __webpack_public_path__ + "images/diagnostics446a7cd62b3c0acb9ebec4785647c651.svg";